import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  className?: string;
};
export function ContentBox({ className = '', children }: Props) {
  return (
    <div className={`rounded-sm p-lg bg-level-02 ${className}`}>{children}</div>
  );
}

ContentBox.displayName = 'ContentBox';
